import {AfterViewInit, Component, OnInit, ViewChild, Input, Inject, Output, EventEmitter} from '@angular/core';
import {ExportBpmnToS3Component} from '../workfloweditor/workfloweditor.component';
import {CamundaService} from '../../camunda.service';
import {ConfService} from '../../conf.service';
import {Route} from '@angular/router';
import {ProcessInstanceComponent} from '../process-instance/process-instance.component';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

const routelist: Route[] = [
    {path: 'processIns', component: ProcessInstanceComponent},
];

@Component({
    selector: 'app-camundaviewer',
    templateUrl: './camundaviewer.component.html',
    styleUrls: ['./camundaviewer.component.scss']
})
export class CamundaviewerComponent implements OnInit, AfterViewInit {

    constructor(private camundaSrv: CamundaService, private confService: ConfService, public platform: LeftpanelComponent) {
    }

    // @ViewChild(BpmnComponent) BpmnComponent: BpmnComponent;
    processId: string;
    getProcessIdDataG: any;
    variables: any;
    xml: any;
    instanceId: any;
    businessKey: any;
    definitionVersion: any;
    definitionID: any;
    definitionKey: any;
    definitionName: any;
    tenantID: any;
    deploymentID: any;
    leftPanel: any;
    leftPanelString: any;
    processInstance: any;
    superProcessInstanceID: any;
    @Input() bpmnVariables: any;
    @Input() deploymentName: any;
    @Input() deploymentSource: any;
    @Input() xmlData: any;
    @Output() executionLogsClosed: EventEmitter<any> = new EventEmitter<any>();
    isExecuted: boolean;
    isBPMNUploadSuccess: boolean;
    currentProcessInstanceId: any;
    showProcessInstance = false;
    processInstanceVariables: any;
    userTasks: any;

    ngOnInit() {
        // this.bpmnVariables = this.data.bpmnVariables;
        // this.deploymentName = this.data.deploymentName;
        // this.deploymentSource = this.data.deploymentSource;
        // this.xmlData = this.data.xmlDataToSend;
        this.getProcessInstance();
    }

    getProcessInstance() {
        this.isBPMNUploadSuccess = false;
        this.isExecuted = true;
        this.showProcessInstance = false;
        const payload = {};
        payload['username'] = 'demo';
        payload['password'] = 'demo';
        payload['url'] = 'https://camunda.apiplatform.io/engine-rest/deployment/create';
        payload['method'] = 'POST';
        // payload['fileName'] = this.workfloweditor.executor_name + this.workfloweditor.selectedVersion + '.bpmn';
        payload['fileName'] = this.deploymentName + '_' + this.deploymentSource + '.bpmn';
        // payload['method'] = 'POST';
        const subPayload = {};
        subPayload['*'] = this.xmlData;
        subPayload['tenant-id'] = localStorage.getItem('partner') + '-' + localStorage.getItem('account');
        // subPayload['deployment-name'] = this.workfloweditor.executor_name + '_' + this.workfloweditor.selectedVersion;
        subPayload['deployment-name'] = this.deploymentName;
        subPayload['enable-duplicate-filtering'] = false;
        // subPayload['deployment-source'] = this.workfloweditor.executor_name + '_' + this.workfloweditor.selectedVersion;
        subPayload['deployment-source'] = this.deploymentSource;
        payload['body'] = subPayload;
        this.leftPanel = [
            // {
            //     "name":"Instance ID",
            //     "value":""
            // },
            // {
            //     "name":"Business Key",
            //     "value":""
            // },
            {
                'name': 'Definition Version',
                'value': ''
            },
            {
                'name': 'Definition ID',
                'value': ''
            },
            {
                'name': 'Definition Key',
                'value': ''
            },
            {
                'name': 'Definition Name',
                'value': ''
            },
            {
                'name': 'Tenant ID',
                'value': ''
            },
            {
                'name': 'Deployment ID',
                'value': ''
            },
            // {
            //     "name":"Super Process Instance ID",
            //     "value":""
            // }
        ];
        this.confService.uploadXMLToCamunda(localStorage.getItem('partner'), localStorage.getItem('account'), payload)
            .subscribe(uploadXMLToCamundaData => {
                    this.tenantID = localStorage.getItem('account');
                    this.camundaSrv.getProcessId(localStorage.getItem('partner'), localStorage.getItem('account'), uploadXMLToCamundaData['id'])
                        .subscribe(getProcessIdData => {
                            this.getProcessIdDataG = getProcessIdData;
                            if (getProcessIdData && this.getProcessIdDataG.length > 0) {
                                this.isExecuted = false;
                                this.isBPMNUploadSuccess = true;
                                let variables = this.bpmnVariables;
                                const temp = {};
                                // for ( let i = 0 ; i < this.bpmnVariables.length ; i++){
                                //     const x = {};
                                //     x['value'] = this.bpmnVariables[i]['variableValue'];
                                //     x['type'] = this.bpmnVariables[i]['variableType'];
                                //     temp[this.bpmnVariables[i]['variableName']] = x;
                                // }
                                // variables['variables'] = temp;
                                // variables['businessKey'] = 'key';
                                this.definitionKey = getProcessIdData[0]['key'];
                                this.definitionID = getProcessIdData[0]['id'];
                                this.definitionName = getProcessIdData[0]['resource'];
                                this.definitionVersion = getProcessIdData[0]['key'].split(':')[1];
                                this.deploymentID = getProcessIdData[0]['deploymentId'];
                                // tslint:disable-next-line:max-line-length
                                if (!variables) {
                                    variables = {
                                        var1: {value: 'shan', type: 'string'}
                                    };
                                }
                                const executionPayload = {
                                    variables: variables
                                };
                                this.camundaSrv.startProcessExecution(localStorage.getItem('partner'), localStorage.getItem('account'), getProcessIdData[0]['id'], variables)
                                    .subscribe(startProcessExecutionData => {
                                            let procesExecutionData: any;
                                            procesExecutionData = startProcessExecutionData;
                                            for (let i = 0; i < this.leftPanel.length; i++) {
                                                if (this.leftPanel[i]['name'] === 'Definition Version') {
                                                    this.leftPanel[i]['value'] = getProcessIdData[0]['version'];
                                                } else if (this.leftPanel[i]['name'] === 'Definition ID') {
                                                    this.leftPanel[i]['value'] = getProcessIdData[0]['id'];
                                                } else if (this.leftPanel[i]['name'] === 'Definition Key') {
                                                    this.leftPanel[i]['value'] = getProcessIdData[0]['key'];
                                                } else if (this.leftPanel[i]['name'] === 'Definition Name') {
                                                    this.leftPanel[i]['value'] = getProcessIdData[0]['name'];
                                                } else if (this.leftPanel[i]['name'] === 'Tenant ID') {
                                                    this.leftPanel[i]['value'] = getProcessIdData[0]['tenantId'];
                                                } else if (this.leftPanel[i]['name'] === 'Deployment ID') {
                                                    this.leftPanel[i]['value'] = getProcessIdData[0]['deploymentId'];
                                                }
                                                // else if (this.leftPanel['name'] === ''){
                                                //     this.leftPanel['value'] = ;
                                                // }
                                            }
                                            this.leftPanelString = JSON.stringify(this.leftPanel);
                                            // this.camundaSrv.getBPMNImage(localStorage.getItem('partner'), this.processId, data['id'])
                                            //     .subscribe(data => {
                                            //     });
                                            this.camundaSrv.getProcessInstances(localStorage.getItem('partner'), localStorage.getItem('account'), getProcessIdData[0]['id'])
                                                .subscribe(processInstance => {
                                                        this.processInstance = processInstance;
                                                        this.isExecuted = true;
                                                    },
                                                    (err) => {
                                                        this.isExecuted = true;
                                                        alert('Error while executing the workflow');
                                                        this.platform.openSnackBar((err !== null && err !== undefined) ? ': ' + err.error.message : 'Error while executing the workflow', 'Error', {
                                                            duration: 5000,
                                                            verticalPosition: 'top',
                                                            horizontalPosition: 'center'
                                                        });
                                                    }
                                                );
                                        },
                                        (err) => {
                                            // this.isExecuted = false;
                                            // this.platform.openSnackBar(err['error']['message'], 'Error', {
                                            //     duration: 5000,
                                            //     verticalPosition: 'top',
                                            //     horizontalPosition: 'center'
                                            // });
                                            this.isExecuted = true;
                                            this.isBPMNUploadSuccess = false;
                                            alert('Error');
                                        });
                            } else {
                                // this.isExecuted = false;
                                this.platform.openSnackBar('Please make workflow as Executable to start executing the BPMN', 'Error', {
                                    duration: 5000,
                                    verticalPosition: 'top',
                                    horizontalPosition: 'center'
                                });
                            }
                        });

                },
                (err) => {
                    this.platform.openSnackBar('Error deploying BPMN file', 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
    }

    closeDialog() {
        //this.dialogRef.close();
    }

    setProcessInstance(id) {
        this.currentProcessInstanceId = id;
        this.camundaSrv.getProcessVariables(localStorage.getItem('partner'), localStorage.getItem('account'), id)
            .subscribe(variables => {
                this.processInstanceVariables = variables;
            }, error => {
                this.platform.handleErrorGracefully(error, 'Error while retrieving variables for process instance');
            });
        this.camundaSrv.getUserTasksInProcessInstance(id).subscribe(response => {
            this.userTasks = response;
            this.showProcessInstance = true;
        }, error => {
            this.platform.handleErrorGracefully(error, 'Error while retrieving user tasks in process instance');
        });

    }

    hideProcessInstance() {
        this.showProcessInstance = false;
    }

    closeExecutionLogs() {
        this.executionLogsClosed.emit();
    }

    ngAfterViewInit() {
    }
}
